'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Underline = function Underline(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 30 30' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M10 23h11v-2H10v2zm5.5-3.8c2.6 0 4.5-2.1 4.5-4.8V9c0-.6-.4-1-1-1s-1 .4-1 1v5.4c0 1.4-.9 2.8-2.5 2.8S13 15.8 13 14.4V9c0-.6-.4-1-1-1s-1 .4-1 1v5.4c0 2.8 1.9 4.8 4.5 4.8z'
      })
    )
  );
};
/*eslint-enable */

exports.default = Underline;
//# sourceMappingURL=Underline.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Underline.js